import config from '../config';

export const FETCH_CUSTOMER_ESCALATION_COUNT_SUCCESS = 'FETCH_CUSTOMER_ESCALATION_COUNT_SUCCESS';
export const UPDATE_CUSTOMER_ESCALATION_COUNT = 'UPDATE_CUSTOMER_ESCALATION_COUNT';

// Fetch total flagged customer count (for sidebar badge)
export function fetchCustomerEscalationCount() {
  return async (dispatch) => {
    try {
      const response = await fetch(`${config.customerApiBase}/customers/count`);
      const data = await response.json();
      const count = data?.count || 0;
      
      dispatch({
        type: FETCH_CUSTOMER_ESCALATION_COUNT_SUCCESS,
        payload: count
      });
      
      return count;
    } catch (error) {
      console.error('Error fetching customer escalation count:', error);
      return 0;
    }
  };
}

// Update count (e.g. from WebSocket or manual refresh)
export function updateCustomerEscalationCount(count) {
  return {
    type: UPDATE_CUSTOMER_ESCALATION_COUNT,
    payload: count
  };
}
